import React from 'react'

const QuoteRequest = () => {
  return (
    <section className='bg-beige w-full flex justify-center items-center py-40 lg:mx-40 mt-32'>
      <div>
        <h2 className='font-tiempo text-azul font-bold mx-12 text-center text-5xl'>Request a quote</h2>
        <p className=' font-basis font-bold text-gray-1 my-8 mx-8 sm:mx-12 py-4 text-xl'>Get a custom quote for orders of 2,000 boxes or more.</p>
        <a href="/" className='bg-azul block py-4 px-8 my-8 mx-24 lg:mx-32 rounded-full text-center font-basis text-white font-bold tracking-widest uppercase text-sm '>REQUEST QUOTE</a>
      </div>
    </section>
  )
}

export default QuoteRequest
